export default "<p>{{status}}</p>\n"